module.exports = __webpack_public_path__ + "static/regresion-036950547bb3df770cf79b5375e067b5.jpg";